import React from 'react';
import PropTypes from 'prop-types';
import EccBenefitsModal from './EccBenefitsModal';

function EccBenefitsModalVM(props) {
  const { freeShippingAndReturnsLegalCopiesData, orderSummaryData } = props;
  const { loading, data } = freeShippingAndReturnsLegalCopiesData;
  const loyalty = orderSummaryData?.orderSummary?.loyalty || {
    loyaltyFreeReturnsEligible: false,
    loyaltyFreeShippingEligible: false,
  };

  if (!loading) {
    const freeShippingAndReturnsLegalCopiesObj = data.freeShippingAndReturnsLegalText || null;
    const freeShippingAndReturnsLegalCopies = freeShippingAndReturnsLegalCopiesObj.legalCopies
    || null;
    if (freeShippingAndReturnsLegalCopies) {
      const ecc = freeShippingAndReturnsLegalCopies.filter((copy) => copy.title === 'ecc');
      const freeReturns = freeShippingAndReturnsLegalCopies.filter(
        (copy) => copy.title === 'free_returns',
      );
      const freeShipping = freeShippingAndReturnsLegalCopies.filter(
        (copy) => copy.title === 'free_shipping',
      );
      const freeShippingAndReturns = freeShippingAndReturnsLegalCopies.filter(
        (copy) => copy.title === 'free_shipping_and_returns',
      );
      const globalFreeShippingOver50 = freeShippingAndReturnsLegalCopies.filter(
        (copy) => copy.title === 'global_free_shipping_over_50',
      );

      const isFreeReturns = loyalty.loyaltyFreeReturnsEligible;
      const isFreeShipping = loyalty.loyaltyFreeShippingEligible;

      let returnText = '';
      if (isFreeReturns && isFreeShipping) {
        [returnText] = freeShippingAndReturns?.[0] || null;
      } else if (!isFreeReturns && !isFreeShipping) {
        returnText = globalFreeShippingOver50?.[0] || null;
      } else if (!isFreeReturns && isFreeShipping) {
        returnText = freeShipping?.[0] || null;
      } else if (isFreeReturns && !isFreeShipping) {
        returnText = freeReturns?.[0] || null;
      }
      const eccText = ecc?.[0] || null;

      return <EccBenefitsModal {...props} returnText={returnText} eccText={eccText} />;
    }

    return null;
  }

  return null;
}

EccBenefitsModalVM.propTypes = {
  freeShippingAndReturnsLegalCopiesData: PropTypes.shape({
    loading: PropTypes.bool,
    data: PropTypes.shape({
      freeShippingAndReturnsLegalText: PropTypes.shape({}),
    }),
  }),
  orderSummaryData: PropTypes.shape({
    orderSummary: PropTypes.shape({
      loyalty: PropTypes.shape({}),
    }),
  }),
};

EccBenefitsModalVM.defaultProps = {
  freeShippingAndReturnsLegalCopiesData: {
    loading: false,
    data: null,
  },
  orderSummaryData: { },
};

export default EccBenefitsModalVM;
